export default __webpack_public_path__ + "static/media/05_orbs.1e60a097.png";